// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgTruckIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M4 4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2 3 3 0 1 0 6 0h4a3 3 0 1 0 6 0 2 2 0 0 0 2-2v-1.675c0-.215-.035-.429-.103-.633l-1.441-4.324A2 2 0 0 0 18.558 8H16V6a2 2 0 0 0-2-2zm12 7a1 1 0 0 1 1-1h1.28a1 1 0 0 1 .948.684l.333 1A1 1 0 0 1 18.613 13H17a1 1 0 0 1-1-1zm-8 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0m9 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
      clipRule="evenodd"
    />
  </g>
);
export default SvgTruckIcon;
SvgTruckIcon.displayName = 'SvgTruckIcon';
